import { ActionMap } from "@models/IContext";

export enum GeneralTypes {
  ResetGroupsManager = "RESET_GROUPS_MANAGER",
}

type GeneralPayload = {
  [GeneralTypes.ResetGroupsManager]: undefined;
};

export type GeneralActions = ActionMap<GeneralPayload>[keyof ActionMap<GeneralPayload>];
